export default {
  id: "coin-game-cpp",
  pride: 9216,
  slug: "coin-game-cpp",
  portfolioKind: "study",
  category: "game",
  status: "released",
  titleKey: {
    zh: "纯C++投币小游戏",
    en: "Pure C++ Coin Mini Game"
  },
  bilibiliVideoId: "BV1BF411N7id",
  date: { year: 2022, month: 7, day: 30 },
  descriptionKey: {
    zh: "课程作业小游戏。规则简单，难度高。纯C++。",
    en: "Course assignment mini game. Simple rules, high difficulty. Pure C++."
  },
  genres: ["小游戏", "课程作业"],
  themes: ["投币", "C++"],
  engine: "虚幻引擎",
  platform: ["PC"],
  developerNotesKey: {
    zh: "投币小游戏，规则简单难度高。纯C++课程作业。",
    en: "Coin mini game. Simple rules, high difficulty. Pure C++ course assignment."
  },
  tags: ["C++", "课程作业"],
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "bilibili", url: "https://www.bilibili.com/video/BV1BF411N7id/", textKey: { zh: "B站视频", en: "Bilibili Video" } },
    { type: "download", url: "https://pan.baidu.com/s/1iwmCjW0VMlAWZ3T95g3IHg?pwd=mxfn", textKey: { zh: "下载（百度云）", en: "Download (Baidu)" } },
  ]
};
